import { Directive, HostListener, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Directive({
  selector: 'a[routerLink]'
})
export class PreserveRegionParamsDirective {
  @Input() routerLink: any;
  @Input() queryParams: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    const currentRegionCode = this.route.snapshot.queryParams.regionCode;

    if (currentRegionCode) {
      event.preventDefault();

      const mergedQueryParams = {
        ...this.queryParams,
        regionCode: currentRegionCode
      };

      this.router.navigate(
        Array.isArray(this.routerLink) ? this.routerLink : [this.routerLink],
        { queryParams: mergedQueryParams }
      );
    }
  }
}